// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"557bcf15","777":"eeabde23"}[chunkId] + ".chunk.js";
};